// extracted by mini-css-extract-plugin
export default {"feed":"IfqXaJ0D","header":"nQ8CdoWg","title":"n4OykN_R","content":"IbHHEaSH","message":"Y8OVLkG1"};